import React from 'react';
import moment from "moment";
import * as utilities from "../../utilities/utils";
import { Fragment } from 'react';
import { useEffect } from 'react';
import { CASE_STATUS } from '../../App.config';

const AccCaseDetailComponent = (props) => {

    useEffect(() => {
        var s = props;
    }, [])

    const getInitialStatus = (statusList, fileStatus) => {
        return statusList.length ? statusList[statusList.length - 1].statusName : fileStatus
    }

    return (
        <>
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-body">
                        <table className="table table-striped">
                            <thead></thead>
                            <tbody>
                                {Array.isArray(props.caseInfo.caseDetail) && props.caseInfo.caseDetail.length
                                    ? props.caseInfo.caseDetail.map((status, index) => (
                                        <Fragment key={`status-${index}`}>
                                            <tr>
                                                <td>
                                                    {/* Case Number */}
                                                    {props.context.t("ACCOMODATION-Case-Number.CA")}
                                                </td>
                                                <td>{status.caseMgmtID ? status.caseMgmtID : "-"}</td>
                                            </tr>
                                            <tr>
                                                <td>{props.context.t("STD-Employer-Statement.form.Employee-Details.label.text.EEName")}</td>
                                                <td>
                                                    {status.firstName} {status.lastName}
                                                </td>
                                            </tr>

                                            <tr>
                                                <td>{props.context.t("ACCOMODATION-Date-Case.Entered.CA")}</td>
                                                <td>
                                                    {status.dateEntered
                                                        ? utilities.formatDate(
                                                            status.dateEntered,
                                                            "MMM DD YYYY"
                                                        )
                                                        : "-"}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>{props.context.t("ACCOMODATION-Date-Closed.CA")}</td>
                                                <td>
                                                    {status.dateClosed
                                                        ? utilities.formatDate(
                                                            status.dateClosed,
                                                            "MMM DD YYYY"
                                                        )
                                                        : "-"}

                                                </td>
                                            </tr>
                                            <tr>
                                                <td>{props.context.t("ACCOMODATION-Case-Type.CA")}</td>
                                                <td>{status.caseType ? status.caseType : "-"}</td>
                                            </tr>
                                            <tr>
                                                <td>{props.context.t("ACCOMODATION-Case-Manager.CA")}</td>
                                                <td>{status.managedBy ? status.managedBy : "-"}</td>
                                            </tr>
                                            <tr>
                                                <td>{props.context.t("ACCOMODATION-Date-Employer.Statement.Received.CA")}</td>
                                                <td>
                                                    {status.dateEmployerStatementReceived
                                                        ? utilities.formatDate(
                                                            status.dateEmployerStatementReceived,
                                                            "MMM DD YYYY"
                                                        )
                                                        : "-"}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>{props.context.t("ACCOMODATION-Date-Attending.Physician.Statement.Received.CA")}</td>
                                                <td>
                                                    {status.attendingPhyStatRecDate
                                                        ? utilities.formatDate(
                                                            status.attendingPhyStatRecDate,
                                                            "MMM DD YYYY"
                                                        )
                                                        : "-"}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>{props.context.t("ACCOMODATION-Date-First.Seen.by.MD.CA")}</td>
                                                <td>
                                                    {status.seenByMDDate
                                                        ? utilities.formatDate(
                                                            status.seenByMDDate,
                                                            "MMM DD YYYY"
                                                        )
                                                        : "-"}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>{props.context.t("ACCOMODATION-File-Status.Information.CA")}</td>
                                                <td>
                                                    {Array.isArray(status.fileStatusInformation) &&
                                                        status.fileStatusInformation.length
                                                        ? status.fileStatusInformation.map((fileStatus) => (
                                                            <Fragment key={fileStatus.statusName}>
                                                                <span>
                                                                    &nbsp;
                                                                    {fileStatus?.statusName}
                                                                    &nbsp;-
                                                                    {moment(fileStatus?.statusDate).format("MMM DD YYYY")}
                                                                </span>
                                                                <br />
                                                            </Fragment>
                                                        ))
                                                        : null}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>{props.context.t("ACCOMODATION-Dates-Medical.Updates.CA")}</td>
                                                <td>
                                                    {status.datesMedicalUpdatesReceived.replace("\r\n", ",")
                                                        || "-"}
                                                </td>
                                            </tr>
                                            {
                                                !CASE_STATUS.isCCM(getInitialStatus(status.fileStatusInformation, status.fileStatus))
                                                &&
                                                <tr>
                                                    <td>{props.context.t("ACCOMODATION-Date-became.Complex.CA")}</td>
                                                    <td>
                                                        {status.complexCaseDate
                                                            ? utilities.formatDate(
                                                                status.complexCaseDate,
                                                                "MMM DD YYYY"
                                                            )
                                                            : "-"}
                                                    </td>
                                                </tr>
                                            }
                                            <tr>
                                                <td>{props.context.t("ACCOMODATION-Case-Status.Information.CA")}</td>
                                                <td>
                                                    {Array.isArray(status.eiDates) &&
                                                        status.eiDates.length
                                                        ? status.eiDates.map((eiDate) => (
                                                            <Fragment key={eiDate.fromDate}>
                                                                <span>
                                                                    &nbsp;{eiDate?.status}
                                                                    &nbsp;-
                                                                    {eiDate.fromDate ? moment(eiDate?.fromDate).format("MMM DD YYYY") : "-"}
                                                                    &nbsp;-&nbsp;
                                                                    {eiDate.toDate ? moment(eiDate?.toDate).format("MMM DD YYYY") : ""}
                                                                    <br />
                                                                    {"Hours:" + eiDate.hrs || eiDate.hrs}
                                                                </span>
                                                                <br />
                                                                <br />
                                                            </Fragment>
                                                        ))
                                                        : "-"}
                                                </td>
                                            </tr>

                                            <tr>
                                                <td>{props.context.t("ACCOMODATION-Restrictions-Limitations.CA")}</td>
                                                <td>
                                                    {status.restrictions && status.restrictions.split("\r\n").length > 0 ?
                                                        <>
                                                            <ul>
                                                                {
                                                                    status.restrictions.split("\r\n").map((res) => (
                                                                        <li>{res}</li>
                                                                    ))
                                                                }
                                                            </ul>
                                                        </> : "-"
                                                    }
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>{props.context.t("ACCOMODATION-Last-Update.File.Status.CA")}</td>
                                                <td>
                                                    {status.lastUpdateFileStatus}
                                                    {status.lastUpdateFileStatusDate
                                                        ? "-" + " " + props.context.t("STD.Completed.on") + " " + utilities.formatDate(
                                                            status.lastUpdateFileStatusDate,
                                                            "MMM DD YYYY"
                                                        )
                                                        : "-"}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>{props.context.t("ACCOMODATION-Next-action.CA")}</td>
                                                <td>{status.nextAction ? status.nextAction : "-"}</td>
                                            </tr>
                                            <tr>
                                                <td>Notes</td>
                                                <td>{status.notes ? status.notes : "-"}</td>
                                            </tr>
                                            {/* {console.log("status.acmdType===>",status)} */}

                                            {
                                                !CASE_STATUS.isCCM(CASE_STATUS.getInitialStatus(status.fileStatusInformation, status.fileStatus))
                                                &&
                                                <tr>
                                                    <td>{props.context.t("ACCOMODATION-Accommodation-Type.CA")}</td>
                                                    {/* <td>{status.acmdType == "0" || status.acmdType == "1" ? (status.acmdType=="1" ? props.context.t("ACCOMODATION-Temporary.CA") : props.context.t("ACCOMODATION-Permanent.CA")): "-"}</td> */}
                                                    {/* <td>{status.acmdType == "1" || status.acmdType == 2 && status.acmdType == 3? (status.acmdType==1 ? props.context.t("ACCOMODATION-Permanent.CA") : status.acmdType==2 ?props.context.t("ACCOMODATION-Temporary.CA"):props.context.t("AIR-Accident-Information.form.label.text.OvertimeToInjuryType.NA")): "-"}</td> */}
                                                    <td>{status.acmdType == "1" || status.acmdType == "2" || status.acmdType == "3" ? (status.acmdType == "1" ? props.context.t("ACCOMODATION-Permanent.CA") : status.acmdType == "2" ? props.context.t("ACCOMODATION-Temporary.CA") : props.context.t("AIR-Accident-Information.form.label.text.OvertimeToInjuryType.NA")) : "-"}</td>

                                                </tr>
                                            }
                                        </Fragment>
                                    ))
                                    : null}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AccCaseDetailComponent;